export function showMore(containerSelector) {
    const showMoreContainer = document.querySelector(containerSelector)
    if (!showMoreContainer) {
        return
    }
    const text = showMoreContainer?.getElementsByClassName('text')[0]
    const labelMore = showMoreContainer?.getElementsByClassName("label-more")[0]
    const labelLess = showMoreContainer?.getElementsByClassName("label-less")[0]
    const toggle = showMoreContainer?.getElementsByTagName("input")[0]

    if (!text || !labelMore || !labelLess || !toggle) {
        console.error('Missing on of mandatory DOM elements for showMore()')
        return;
    }

    function isTruncated(element) {
        return element.scrollHeight > element.offsetHeight;
    }

    if (isTruncated(text)) {
        labelMore.style.display = "inline-block"
    }

    labelLess.style.display = "none"

    toggle.addEventListener("change", function () {
        if (toggle.checked) {
            labelLess.style.display = "inline-block";
            labelMore.style.display = "none"
        } else {
            labelLess.style.display = "none"
            if (isTruncated(text)) {
                labelMore.style.display = "inline-block"
            }
        }
    });
}